import { App } from 'antd';
import { useTranslation } from 'react-i18next';

type OnCopy = (data: string) => void;
type OnPaste = () => Promise<string>;

type UseCopy = () => {
  onCopy: OnCopy;
  onPaste: OnPaste;
}

const useCopy: UseCopy = () => {
  const { t } = useTranslation();
  const { notification } = App.useApp();

  const onCopy:OnCopy = async (data) => {
    try {
      await navigator.clipboard.writeText(data);
      notification.success({ placement: 'top', message: t('common.copySuccess') })
    } catch (err) {
      console.error('Failed to copy: ', err);
      notification.error({ placement: 'top', message: t('common.copyError') })
    }
  }

  const onPaste:OnPaste = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const text = await navigator.clipboard.readText();
        resolve(text);
      } catch (err) {
        console.error('Failed to read clipboard contents:', err);
        reject("")
      }
    })
  }

	return { onCopy, onPaste }
};

export default useCopy;
